import { useState } from 'react';
import { Outlet, useLocation } from 'routes';
import { RouterBreadcrumbs } from 'containers';
import style from './routes.module.css';
import CanTab from 'containers/cantabs/components/CanTab';
import { useMediaQuery, useTheme } from '@mui/material';
import {
	getCanTabState,
	setCanTabState,
} from 'containers/cantabs/libs/useLocalStorage';
import { CommandPaletteProvider } from 'contextProviders/CommandPaletteProvider';
import { CommandPalette } from 'components/commandPalette';
import { useSidebarTourControl } from 'components/onboarding/tour/useSidebarTourControl';
import { useHomeTourControl } from 'components/onboarding/tour/useHomeTourControl';

// Routes that should hide the breadcrumb navigation
const FULL_SCREEN_ROUTES = ['/canai'];

const SharedLayout = () => {
	const theme = useTheme();
	const isMd = useMediaQuery(theme.breakpoints.down('md'));
	const [open, setOpen] = useState(!isMd);
	const location = useLocation();

	// Check if current route should hide breadcrumbs (handle trailing slash)
	const normalizedPath = location.pathname.replace(/\/$/, '');
	const hideBreadcrumbs = FULL_SCREEN_ROUTES.includes(normalizedPath);

	const onOpen = () => {
		const canTabSettings = getCanTabState();
		canTabSettings.menuState = 'open';
		setCanTabState(canTabSettings);
		setOpen(true);
	};

	const onClose = () => {
		const canTabSettings = getCanTabState();
		canTabSettings.menuState = 'closed';
		setCanTabState(canTabSettings);
		setOpen(false);
	};

	// Lets the Manage Sites tour force the sidebar open + advance the menu steps.
	useSidebarTourControl(onOpen);
	// Lets the CANapps Home Tour react to the sidebar's open/closed state (skip or
	// run the "open the menu" step, then advance to the profile step).
	useHomeTourControl(open);

	return (
		<CommandPaletteProvider>
			<main className={style.shared_layout}>
				<CanTab open={open} onOpen={onOpen} onClose={onClose} isMd={isMd} />
				<section className={style.right_section}>
					{!hideBreadcrumbs && (
						<RouterBreadcrumbs open={open} onOpen={onOpen} onClose={onClose} isMd={isMd} />
					)}
					<div className={style.outlet}>
						<Outlet />
					</div>
				</section>
				<CommandPalette />
			</main>
		</CommandPaletteProvider>
	);
};

export default SharedLayout;
